import { render } from "./Shop.vue?vue&type=template&id=44435be5&scoped=true&ts=true"
import script from "./Shop.vue?vue&type=script&lang=ts"
export * from "./Shop.vue?vue&type=script&lang=ts"

import "./Shop.vue?vue&type=style&index=0&id=44435be5&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44435be5"]])

export default __exports__